import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Route } from "lucide-react";
import { Reveal, SectionHeading } from "@/components/Reveal";
import { api } from "@/lib/api";

export const ProgramsTeaser = () => {
  const [countries, setCountries] = useState([]);

  useEffect(() => {
    api.get("/programs/countries").then(({ data }) => setCountries((data || []).slice(0, 4))).catch(() => setCountries([]));
  }, []);

  if (!countries.length) return null;

  return (
    <section id="programs" data-testid="programs-teaser" className="relative py-24 sm:py-32 overflow-hidden">
      <div className="absolute -top-40 -start-40 h-[480px] w-[480px] rounded-full bg-[#C80000]/12 blur-[140px]" aria-hidden="true" />
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="flex flex-wrap items-end justify-between gap-6 mb-12">
          <div>
            <SectionHeading caption="مسارات جاهزة للإلهام" title="برامج سياحية مقترحة" />
            <Reveal delay={0.1}>
              <p className="text-sm sm:text-base leading-loose text-slate-600 max-w-xl">
                برامج مرتبة بالمدن والليالي والأنشطة من مصادر رسمية — كل برنامج مقترح قابل للتخصيص حسب رغبتكم.
              </p>
            </Reveal>
          </div>
          <Reveal delay={0.15}>
            <Link
              to="/programs"
              data-testid="programs-teaser-cta"
              className="inline-flex items-center gap-2 rounded-full bg-[#C80000] px-7 py-3.5 text-sm font-bold text-white hover:bg-[#E01010] transition-colors duration-300"
            >
              <Route className="h-4 w-4" />
              كل البرامج
              <ArrowLeft className="h-4 w-4" />
            </Link>
          </Reveal>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
          {countries.map((c, i) => (
            <Reveal key={c.slug} delay={0.08 * i}>
              <Link
                to={`/programs/${c.slug}`}
                data-testid={`programs-teaser-country-${c.slug}`}
                className="group relative block rounded-3xl border border-slate-200 overflow-hidden hover:border-[#C80000]/40 transition-colors"
              >
                {c.heroImage?.file ? (
                  <img src={c.heroImage.file} alt={c.name} loading="lazy" className="h-40 sm:h-52 w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                ) : (
                  <div className="h-40 sm:h-52 bg-gradient-to-br from-[#C80000]/20 to-[#E2E8F0]" />
                )}
                <div className="absolute inset-0 bg-gradient-to-t from-[#FFFFFF]/90 via-transparent to-transparent" />
                <div className="absolute bottom-4 start-4">
                  <p className="text-base sm:text-lg font-black text-white">{c.name}</p>
                  <p className="text-[11px] text-slate-600 mt-0.5">{c.programCount} برامج مقترحة</p>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
